<!-- eslint-disable -->
<template lang="pug">
  .examples-viewer
    .examples-viewer__examples
      .example(v-for="(example, index) in examplesArray")
        .example__container(:style="exampleStyle(index)")
          .example__title
            | {{ $i18n.t('trainer.trainer_gamePlayBox_example') }} {{ getExampleNumber(index) }}
          .example__expression(v-for="emoji in example.emojiArray" )
            img.factorization__emoji(:src='emoji[0]')
            | *
            img.factorization__emoji(:src='emoji[1]')
            | =
            | {{ example.result }}
          .example__answer(v-for="answer in example.correctAnswers" )
            | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}: {{ getAnswer(answer) }}
    .examples-viewer__button
      cs-button(
        color="blue"
        @click="$router.push({ name: 'dashboard' })"
      )
        | {{ $i18n.t('common.common_navigation_goToMain') }}
</template>

<script>
    /*eslint-disable*/
    import CsButton from '@/elements/CsButton.vue';

    export default {
        components: { CsButton },
        props: {
            examplesArray: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                colors: [
                    'hsl(121, 58%, 58%)',
                    'hsl(212, 100%, 56%)',
                    'hsl(15, 100%, 64%)',
                    'hsl(38, 100%, 56%)',
                    'hsl(331, 100%, 68%)',
                    'hsl(158, 62%, 54%)',
                    'hsl(284, 59%, 64%)',
                    'hsl(195, 86%, 64%)',
                ],
            };
        },
        methods: {
            getExampleNumber(index) {
                return index + 1;
            },
            getAnswer(answer) {
                return `${answer[0]} * ${answer[1]}`;
            },
            exampleStyle(index) {
                return { color: this.colors[index % this.colors.length] };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .examples-viewer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .examples-viewer__examples {
        display: flex;
        margin: -10px -10px 0;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        font-size: $font-size-24;
    }

    .example {
        display: flex;
        padding: 10px;
    }

    .example__action:nth-child(2n) {
        filter: hue-rotate(10deg) saturate(50%);
    }

    .example__container {
        background-color: $x-color-white;
        padding: 10px;
        border: 1px solid;
        border-radius: $border-radius-10;
    }

    .example__title,
    .example__expression,
    .example__answer {
        @include stack-space($space-x-small);
    }

    .examples-viewer__button {
        margin-top: 20px;
    }

    .factorization__emoji {
        width: 0.75em;
        height: 0.75em;
    }
</style>
